module.exports = __webpack_public_path__ + "img/icon_yongshui.76c17f51.svg";